
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://hidccmqapkiyczyleerr.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhpZGNjbXFhcGtpeWN6eWxlZXJyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQyODA5MDcsImV4cCI6MjA1OTg1NjkwN30.LAc4BSSEdGjt5YwMnF7Y5aZO8Z48fCw_m_vtNFlhWKI";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    storage: localStorage,
    flowType: 'pkce'
  }
});
